import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { fetchLaws } from '@/lib/weaviate/fetch-laws';

export const Route = createFileRoute('/experimental/_experimentalLayout/laws')({
  component: LawsPage,
});

type LawsSearchResult = {
  file_name: string;
  body: string;
  _additional: {
    certainty: number;
  };
};

function LawsPage() {
  const [searchText, setSearchText] = useState('');
  const [results, setResults] = useState<LawsSearchResult[]>([]);
  const [loading, setLoading] = useState(false);

  const handleSearch = async () => {
    if (!searchText.trim()) return;

    setLoading(true);
    try {
      const data = await fetchLaws(searchText);
      setResults(data as LawsSearchResult[]);
    } catch (error) {
      console.error('Error fetching results:', error);
      setResults([]);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4">
      <Card>
        <CardContent className="flex flex-row gap-2 p-4">
          <Input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Enter search text..."
            className="flex-grow"
          />
          <Button onClick={handleSearch} disabled={loading} variant="default">
            {loading ? 'Searching...' : 'Search'}
          </Button>
        </CardContent>
      </Card>

      <div className="mt-4 space-y-4">
        {results.map((result, index) => (
          <Card key={index}>
            <CardHeader>
              <CardTitle>Law {result.file_name}</CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Body</Label>
                  <div>{result.body}</div>
                </div>

                <div className="space-y-2">
                  <Label>Bestandsnaam</Label>
                  <div>{result.file_name}</div>
                </div>
                <div className="space-y-2">
                  <Label>Certainty</Label>
                  <div>{Math.round(result._additional.certainty * 100)}%</div>
                </div>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
}
